export const playFabSettings = {
    TitleId:"9FB84"
}